<template>
    <bottom-sheet v-model="shows" title="미팅매칭하기" fullscreen persistent max-width="1200">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <meeting-view-tabs v-bind="{ meeting }">
                <template #tab-complete-actions>
                    <v-btn color="primary" @click="shows = false">창 닫기</v-btn>
                </template>
            </meeting-view-tabs>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initMeeting } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import MeetingViewTabs from "./meeting-view-tabs.vue";

export default {
    components: {
        BottomSheet,
        MeetingViewTabs,
    },
    props: {
        value: { type: Object, default: initMeeting },
    },
    data: () => ({
        meeting: initMeeting(),

        tab: 0,
        shows: false,
        loading: false,
    }),
    watch: {
        shows() {
            if (this.shows) this.init();
            else if (this.meeting?._id) this.$emit("input", this.meeting);
        },
    },
    methods: {
        async init() {
            this.tab = 0;
            this.loading = false;

            try {
                const { meeting } = await api.v1.person.meetings.get({ _id: this.value?._id });
                this.meeting = meeting;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
